import {
    Library,
    ProjectDetails,
    QuickscanDefinition,
    QuickscanResult,
    TisDefinition,
    ProjectMandateDetails
} from '..';
import {ProjectAnalysisDefinition} from '../project-analysis';
import {IPdfDetails} from './pdf-details-data';
import {Question} from "../definition/question";

export class PdfDetails {
    public projectDetails: ProjectDetails;
    public quickscanResult: QuickscanResult;
    public tisQuickscanResult: QuickscanResult;
    public tisDefinition?: TisDefinition;
    public quickscanDefinition: QuickscanDefinition;
    public risksLibrary: Library;
    public opportunitiesLibrary: Library;
    public mandateDetails?: ProjectMandateDetails;
    public projectAnalysisDefinition?: ProjectAnalysisDefinition;

    constructor(data: IPdfDetails) {
        this.projectDetails = new ProjectDetails(data.projectDetails);
        this.quickscanResult = new QuickscanResult(data.quickscanResult);
        this.tisQuickscanResult = new QuickscanResult(data.tisQuickscanResult);
        this.tisDefinition = data.tisDefinition ? new TisDefinition(data.tisDefinition) : undefined;
        this.quickscanDefinition = new QuickscanDefinition(data.quickscanDefinition);
        this.risksLibrary = new Library(data.risksLibrary);
        this.opportunitiesLibrary = new Library(data.opportunitiesLibrary);
        this.mandateDetails = data.mandateDetails ? new ProjectMandateDetails(data.mandateDetails) : undefined;
        this.projectAnalysisDefinition = data.projectAnalysisDefinition
            ? new ProjectAnalysisDefinition(data.projectAnalysisDefinition)
            : undefined;
    }

    public getProjectAnalysisQuestions(): Question[] {
        if (this.projectAnalysisDefinition) {
            return this.projectAnalysisDefinition.questions;
        }
        return [];
    }

    public findProjectAnalysisQuestion(questionId: number): Question | null {
        return this.getProjectAnalysisQuestions().find(question => question.id === questionId) || null;
    }
}
